import { getNewGraphNumber } from 'business/data-analysis/services/get-new-graph-number';

import { GraphPageState } from './../types';
import { createEmptyGraph } from './utils/create-empty-graph';

export const addGraph = (graphSet: GraphPageState): GraphPageState => {
  const graphs = graphSet.structure.graphs;

  const graphNumber = getNewGraphNumber(Array.from(graphs.values()));

  const { id, newGraph } = createEmptyGraph(
    graphNumber,
    graphSet.structure.type,
  );
  graphs.set(id, newGraph);

  const res = {
    ...graphSet,
    structure: {
      ...graphSet.structure,
      graphs,
    },
  } satisfies GraphPageState;

  return res;
};
